export default __webpack_public_path__ + "c43791483acbe6fe5784edbdfe4afb05.svg";